import { defineMessages } from "react-intl";

export default defineMessages({
  noRecords: {
    id: "KendoGrid.noRecords",
    defaultMessage: "No records available",
  },
  pagerInfo: {
    id: "KendoGrid.pagerInfo",
    defaultMessage: "{0} - {1} of {2} items",
  },
  pagerFirstPage: {
    id: "KendoGrid.pagerFirstPage",
    defaultMessage: "Go to the first page",
  },
  pagerPreviousPage: {
    id: "KendoGrid.pagerPreviousPage",
    defaultMessage: "Go to the previous page",
  },
  pagerNextPage: {
    id: "KendoGrid.pagerNextPage",
    defaultMessage: "Go to the next page",
  },
  pagerLastPage: {
    id: "KendoGrid.pagerLastPage",
    defaultMessage: "Go to the last page",
  },
  pagerItemPerPage: {
    id: "KendoGrid.pagerItemsPerPage",
    defaultMessage: "items per page",
  },
  pagerPage: {
    id: "KendoGrid.pagerPage",
    defaultMessage: "Page",
  },
  pagerOf: {
    id: "KendoGrid.pagerOf",
    defaultMessage: "of",
  },
  pagerTotalPages: {
    id: "KendoGrid.pagerTotalPages",
    defaultMessage: "{0}",
  },
  groupPanelEmpty: {
    id: "KendoGrid.groupPanelEmpty",
    defaultMessage: "Drag a column header and drop it here to group by that column",
  },
  groupColumn: {
    id: "KendoGrid.groupColumn",
    defaultMessage: "Group Column",
  },
  ungroupColumn: {
    id: "KendoGrid.ungroupColumn",
    defaultMessage: "Ungroup Column",
  },
  filterClearButton: {
    id: "KendoGrid.filterClearButton",
    defaultMessage: "Clear",
  },
  filterSubmitButton: {
    id: "KendoGrid.filterSubmitButton",
    defaultMessage: "Filter",
  },
  filterTitle: {
    id: "KendoGrid.filterTitle",
    defaultMessage: "Filter",
  },
  sortAscending: {
    id: "KendoGrid.sortAscending",
    defaultMessage: "Sort Ascending",
  },
  sortDescending: {
    id: "KendoGrid.sortDescending",
    defaultMessage: "Sort Descending",
  },
  searchPlaceholder: {
    id: "KendoGrid.searchPlaceholder",
    defaultMessage: "Search",
  },
  filterCheckAll: {
    id: "KendoGrid.filterCheckAll",
    defaultMessage: "Check All",
  },
  filterChooseOperator: {
    id: "KendoGrid.filterChooseOperator",
    defaultMessage: "Choose Operator",
  },
  filterSelectedItems: {
    id: "KendoGrid.filterSelectedItems",
    defaultMessage: "selected items",
  },
  sortAriaLabel: {
    id: "KendoGrid.sortAriaLabel",
    defaultMessage: "Sortable",
  },
  filterAriaLabel: {
    id: "KendoGrid.filterAriaLabel",
    defaultMessage: "Filter",
  },
  groupExpand: {
    id: "KendoGrid.groupExpand",
    defaultMessage: "Expand group",
  },
  groupCollapse: {
    id: "KendoGrid.groupCollapse",
    defaultMessage: "Collapse Group",
  },
  detailExpand: {
    id: "KendoGrid.detailExpand",
    defaultMessage: "Expand detail row",
  },
  detailCollapse: {
    id: "KendoGrid.detailCollapse",
    defaultMessage: "Collapse detail row",
  },
  filterEqOperator: {
    id: "KendoGrid.filterEqOperator",
    defaultMessage: "Is equal to",
  },
  filterNotEqOperator: {
    id: "KendoGrid.filterNotEqOperator",
    defaultMessage: "Is not equal to",
  },
  filterIsNullOperator: {
    id: "KendoGrid.filterIsNullOperator",
    defaultMessage: "Is null",
  },
  filterIsNotNullOperator: {
    id: "KendoGrid.filterIsNotNullOperator",
    defaultMessage: "Is not null",
  },
  filterIsEmptyOperator: {
    id: "KendoGrid.filterIsEmptyOperator",
    defaultMessage: "Is empty",
  },
  filterIsNotEmptyOperator: {
    id: "KendoGrid.filterIsNotEmptyOperator",
    defaultMessage: "Is not empty",
  },
  filterStartsWithOperator: {
    id: "KendoGrid.filterStartsWithOperator",
    defaultMessage: "Starts with",
  },
  filterContainsOperator: {
    id: "KendoGrid.filterContainsOperator",
    defaultMessage: "Contains",
  },
  filterNotContainsOperator: {
    id: "KendoGrid.filterNotContainsOperator",
    defaultMessage: "Does not contain",
  },
  filterEndsWithOperator: {
    id: "KendoGrid.filterEndsWithOperator",
    defaultMessage: "Ends with",
  },
  filterGteOperator: {
    id: "KendoGrid.filterGteOperator",
    defaultMessage: "Is greater than or equal to",
  },
  filterGtOperator: {
    id: "KendoGrid.filterGtOperator",
    defaultMessage: "Is greater than",
  },
  filterLteOperator: {
    id: "KendoGrid.filterLteOperator",
    defaultMessage: "Is less than or equal to",
  },
  filterLtOperator: {
    id: "KendoGrid.filterLtOperator",
    defaultMessage: "Is less than",
  },
  filterIsTrue: {
    id: "KendoGrid.filterIsTrue",
    defaultMessage: "Is true",
  },
  filterIsFalse: {
    id: "KendoGrid.filterIsFalse",
    defaultMessage: "Is false",
  },
  filterBooleanAll: {
    id: "KendoGrid.filterBooleanAll",
    defaultMessage: "(All)",
  },
  filterAfterOrEqualOperator: {
    id: "KendoGrid.filterAfterOrEqualOperator",
    defaultMessage: "Is after or equal to",
  },
  filterAfterOperator: {
    id: "KendoGrid.filterAfterOperator",
    defaultMessage: "Is after",
  },
  filterBeforeOperator: {
    id: "KendoGrid.filterBeforeOperator",
    defaultMessage: "Is before",
  },
  filterBeforeOrEqualOperator: {
    id: "KendoGrid.filterBeforeOrEqualOperator",
    defaultMessage: "Is before or equal to",
  },
  filterAndLogic: {
    id: "KendoGrid.filterAndLogic",
    defaultMessage: "Andd",
  },
  filterOrLogic: {
    id: "KendoGrid.filterOrLogic",
    defaultMessage: "Or",
  },
});